/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DeploymentMode,
    DeploymentModeFromJSON,
    DeploymentModeFromJSONTyped,
    DeploymentModeToJSON,
} from './DeploymentMode';
import {
    FirmwareType,
    FirmwareTypeFromJSON,
    FirmwareTypeFromJSONTyped,
    FirmwareTypeToJSON,
} from './FirmwareType';
import {
    StbGroupEtcResponse,
    StbGroupEtcResponseFromJSON,
    StbGroupEtcResponseFromJSONTyped,
    StbGroupEtcResponseToJSON,
} from './StbGroupEtcResponse';

/**
 * 
 * @export
 * @interface StbGroupResponse
 */
export interface StbGroupResponse {
    /**
     * 
     * @type {string}
     * @memberof StbGroupResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof StbGroupResponse
     */
    deviceTypeId: string | null;
    /**
     * 
     * @type {string}
     * @memberof StbGroupResponse
     */
    superGroupId: string | null;
    /**
     * 
     * @type {string}
     * @memberof StbGroupResponse
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof StbGroupResponse
     */
    description: string | null;
    /**
     * 
     * @type {string}
     * @memberof StbGroupResponse
     */
    upgradeRuleId: string | null;
    /**
     * 
     * @type {DeploymentMode}
     * @memberof StbGroupResponse
     */
    deploymentMode: DeploymentMode;
    /**
     * 
     * @type {boolean}
     * @memberof StbGroupResponse
     */
    enableQuota: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof StbGroupResponse
     */
    bpProfile: number | null;
    /**
     * 
     * @type {number}
     * @memberof StbGroupResponse
     */
    quota: number | null;
    /**
     * 
     * @type {FirmwareType}
     * @memberof StbGroupResponse
     */
    quotaFirmwareType: FirmwareType;
    /**
     * 
     * @type {number}
     * @memberof StbGroupResponse
     */
    quotaDailyIncrement: number | null;
    /**
     * 
     * @type {string}
     * @memberof StbGroupResponse
     */
    quotaBypassLoaderVersion: string | null;
    /**
     * 
     * @type {string}
     * @memberof StbGroupResponse
     */
    quotaBypassFwVersion: string | null;
    /**
     * 
     * @type {string}
     * @memberof StbGroupResponse
     */
    quotaBypassUiVersion: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StbGroupResponse
     */
    ipGroup: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof StbGroupResponse
     */
    ipMask: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StbGroupResponse
     */
    isIpGroup: boolean | null;
    /**
     * 
     * @type {StbGroupEtcResponse}
     * @memberof StbGroupResponse
     */
    etc: StbGroupEtcResponse;
}

export function StbGroupResponseFromJSON(json: any): StbGroupResponse {
    return StbGroupResponseFromJSONTyped(json, false);
}

export function StbGroupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StbGroupResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'deviceTypeId': json['deviceTypeId'],
        'superGroupId': json['superGroupId'],
        'name': json['name'],
        'description': json['description'],
        'upgradeRuleId': json['upgradeRuleId'],
        'deploymentMode': DeploymentModeFromJSON(json['deploymentMode']),
        'enableQuota': json['enableQuota'],
        'bpProfile': json['bpProfile'],
        'quota': json['quota'],
        'quotaFirmwareType': FirmwareTypeFromJSON(json['quotaFirmwareType']),
        'quotaDailyIncrement': json['quotaDailyIncrement'],
        'quotaBypassLoaderVersion': json['quotaBypassLoaderVersion'],
        'quotaBypassFwVersion': json['quotaBypassFwVersion'],
        'quotaBypassUiVersion': json['quotaBypassUiVersion'],
        'ipGroup': json['ipGroup'],
        'ipMask': json['ipMask'],
        'isIpGroup': json['isIpGroup'],
        'etc': StbGroupEtcResponseFromJSON(json['etc']),
    };
}

export function StbGroupResponseToJSON(value?: StbGroupResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'deviceTypeId': value.deviceTypeId,
        'superGroupId': value.superGroupId,
        'name': value.name,
        'description': value.description,
        'upgradeRuleId': value.upgradeRuleId,
        'deploymentMode': DeploymentModeToJSON(value.deploymentMode),
        'enableQuota': value.enableQuota,
        'bpProfile': value.bpProfile,
        'quota': value.quota,
        'quotaFirmwareType': FirmwareTypeToJSON(value.quotaFirmwareType),
        'quotaDailyIncrement': value.quotaDailyIncrement,
        'quotaBypassLoaderVersion': value.quotaBypassLoaderVersion,
        'quotaBypassFwVersion': value.quotaBypassFwVersion,
        'quotaBypassUiVersion': value.quotaBypassUiVersion,
        'ipGroup': value.ipGroup,
        'ipMask': value.ipMask,
        'isIpGroup': value.isIpGroup,
        'etc': StbGroupEtcResponseToJSON(value.etc),
    };
}

